import { v4 as uuid } from "uuid";

export const NewCustomerFinalResponse = (state: any) => {
   const { newCustomerAPIRes, productType, newCustomerData, productFormData, deliveryAddressData } = state;

   // Map values from productFormData to newCustomerAPIRes
   newCustomerAPIRes['T_FullName'] = productFormData?.fullName ? productFormData.fullName : '';
   newCustomerAPIRes['T_MSISDN'] = productFormData?.prefix && productFormData?.mobileNumber ? productFormData.prefix + productFormData.mobileNumber : '';
   newCustomerAPIRes['AP_ID'] = newCustomerData?.idNumber;
   newCustomerAPIRes['Z_Address_City'] = deliveryAddressData?.city;
   newCustomerAPIRes['Z_Address_District'] = deliveryAddressData?.districtName;
   newCustomerAPIRes['Z_Address_Street'] = deliveryAddressData?.streetName;
   newCustomerAPIRes['Z_Address_Building'] = deliveryAddressData?.buildingNo;
   newCustomerAPIRes['Z_Delivery_Note_Region'] = deliveryAddressData?.region;
   newCustomerAPIRes['Z_DD_Comments'] = deliveryAddressData?.shortAddress;

   const apiProductType = state.productType === 'Fiber' ? 'Fixed_Internet': state.productType;

   newCustomerAPIRes['ZKUT_ProductSegment'] = apiProductType;


   let seq = 0;
   const productInformationData = state.productInformationData.length > 0 && state.productInformationData.map((item: any) => {
      seq = seq + 10;
      const mrc = item.productInformation.packageName?.mrc ? item.productInformation.packageName.mrc : '0'
      const nrc = item.productInformation.packageName?.nrc ? item.productInformation.packageName.nrc : '0'
      const quantity = item?.productInformation?.quantity?.value ? String(item.productInformation.quantity.value) : '1'
      const product = {
         ID: seq,
         ItemProduct: {
            ProductID: item.productInformation.packageName?.product_Id,
            ProductTypeCode: "1",
         },
         Quantity: quantity,
         ZOrderType: item.productInformation.orderType?.value === "New Activation" ? "101" : "111",
         ZPackageMode: item.productInformation.packageName?.mode_sfaId,
         ZPackageType: item.productInformation.packageName?.packageType_sfaId,
         ZSIMType: item.productInformation.packageName?.simType_sfa,
         GeoLatitude: item.productInformation.latitude?.value,
         GeoLongitude: item.productInformation.longitude?.value,
         NRC: nrc,
         MRC: mrc,
         TVC: String((parseFloat(mrc) * parseFloat(quantity)) + parseFloat(nrc)),
         ZProductDescription: item?.productInformation?.packageName?.name
      };

      return product;
   })
   const topProductInfo = state.productInformationData[0].productInformation;
   newCustomerAPIRes['Item'] = productInformationData
   newCustomerAPIRes['ID'] = state.randomID
   if (['Fiber', 'SIP'].includes(productType)) {
      newCustomerAPIRes['Z_ODBOperator'] = (productType === 'SIP' && topProductInfo.installed === 'yes') ? "mobily" : topProductInfo.ODBOperator?.value
      newCustomerAPIRes['ZODBNumber'] = topProductInfo.ODBNumber?.value
      newCustomerAPIRes['ZZExisitng_Flag'] = "2"
   }
   if (productType === 'SIP' && (topProductInfo.installed !== 'yes' || topProductInfo.IPPBX !== 'yes' || topProductInfo.telephoneDevice !== 'yes' || topProductInfo.telecomEquipment !== 'yes')) {
      newCustomerAPIRes['OriginTypeCode'] = 'Z07'
      newCustomerAPIRes['ZDocumentType'] = 'Z104'
   }

   const createId = uuid()
   const ID = createId.replaceAll(/-/g, "").toUpperCase();
   const UUID = createId;

   const finalResponse = {
      "MOBILY_BSL_SR": {
         "SR_HEADER": {
            "FuncId": "CreateOpportunitySFA",
            "MsgVersion": "0001",
            "RequestorUserId": "ePortal",
            "RequestorChannelId": "ePortalUser",
            "ChannelTransactionId": `SR_${state.dateString}`,
            "SrDate": state.dateString
         },
         "OpportunityReq": {
            "Envelope": {
               "Body": {
                  "LeanLeadReplicationBulkReplicateRequest": {
                     "MessageHeader": {
                        "ID": ID,
                        "UUID": UUID,
                        "CreationDateTime": state.createdTime,
                        "ExistingCustomer": "N", //This Flag is created for EAI identify between the existing and new customer as the input parameters are different in both cases. 
                        "SenderBusinessSystemID": "", //Static
                        "RecipientBusinessSystemID": "", //Static
                        "SenderParty": {
                           "InternalID": "" //Static
                        },
                        "RecipientParty": {
                           "InternalID": "" //Static
                        }
                     },
                     "LeanLeadReplicateRequestMessage": {
                        "MessageHeader": {
                           "UUID": UUID
                        },
                        "LeanLead": newCustomerAPIRes,
                     }
                  }
               }
            }
         },
         "AttachmentReq": {
            "Envelope": {
               "Header": "",
               "Body": {
                  "AttachmentFolderBulkReplicateRequest": {
                     "MessageHeader": {
                        "ID": ID,
                        "UUID": UUID,
                        "CreationDateTime": state.createdTime,
                        "SenderBusinessSystemID": "",
                        "RecipientBusinessSystemID": "",
                        "SenderParty": {
                           "InternalID": ""
                        },
                        "RecipientParty": {
                           "InternalID": ""
                        }
                     },
                     "AttachmentFolderReplicateRequestMessage": {
                        "BasicMessageHeader": {
                           "UUID": UUID
                        },
                        "AttachmentFolder": {
                           "HostObjectReference": {
                              "ObjectTypeCode": "",
                              "ObjectID": state.randomID
                           },
                           "Document": state.downloadAttachmentData
                        }
                     }
                  }
               }
            }
         }
      }
   }
   return finalResponse;
}